import { render, staticRenderFns } from "./ManagersTable.vue?vue&type=template&id=1762c6e1&scoped=true"
import script from "./ManagersTable.vue?vue&type=script&lang=ts"
export * from "./ManagersTable.vue?vue&type=script&lang=ts"
import style0 from "./ManagersTable.vue?vue&type=style&index=0&id=1762c6e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1762c6e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1762c6e1')) {
      api.createRecord('1762c6e1', component.options)
    } else {
      api.reload('1762c6e1', component.options)
    }
    module.hot.accept("./ManagersTable.vue?vue&type=template&id=1762c6e1&scoped=true", function () {
      api.rerender('1762c6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/ManagersTable.vue"
export default component.exports